import { css } from "@emotion/react";
import { fade } from "@material-ui/core/styles";

import theme from "../../styles/theme";
import { white } from "../../styles/variables";

export const container = css`
  height: 100%;
  width: 100%;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: inherit;
  padding: ${theme.spacing(5)}px 0;
`;

export const center = css`
  justify-content: center;
`;

export const backdrop = css`
  background: ${fade(white, 0.5)};
  z-index: 5000;
`;

export const errorWrapper = css`
  text-align: center;
`;

export const btn = css`
  margin-top: ${theme.spacing(2)}px;
`;
